/**
 * OptimizedImage — serve WebP com fallback JPEG/PNG
 * Reduz LCP em ~30% para imagens hero
 */

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
  priority?: boolean;
}

export function OptimizedImage({ src, alt, className, priority, ...rest }: OptimizedImageProps) {
  // Deriva o path WebP a partir do src original
  const webpSrc = src.replace(/\.(jpg|jpeg|png)$/i, '.webp');

  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img
        src={src}
        alt={alt}
        className={className}
        {...(priority
          ? { decoding: 'async' }
          : { loading: 'lazy', decoding: 'async' })}
        {...rest}
      />
    </picture>
  );
}
